import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@domestika-dev/prudencio/dist/molecules/Modal";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Loader } from "@domestika-dev/prudencio/dist/atoms/Loader";
import { FormattedMessage } from "react-intl";

const LoaderModal = ({ isOpen }) => (
  <Modal
    width="auto"
    heigth="auto"
    isOpen={isOpen}
    id="dmstk-loading-modal"
    onModalClose={() => {}}
  >
    <Modal.Content>
      <Flex alignItems="center" flexDirection="column" justifyContent="center">
        <Loader size="medium" paddingBottom={3} />
        <Text size="medium" textAlign="center">
          <FormattedMessage
            id="projects.new.saving.confirmation_message"
            values={{ linebreak: <br /> }}
          />
        </Text>
      </Flex>
    </Modal.Content>
  </Modal>
);

LoaderModal.propTypes = {
  isOpen: PropTypes.bool,
};

LoaderModal.defaultProps = {
  isOpen: false,
};

export default LoaderModal;
